import { MemberType } from './types';

export const defaultData: MemberType = {
  first_name: '',
  last_name: '',
  phone_number: '',
  email: '',
  dob: '',
  department_name: '',
  budget: '',
  budget_duration: '',
  budget_setting: '',
  role: 'MEMBER'
};
